export interface BodyDiagramData {
  view: {
    front: boolean;
    back: boolean;
  };
  notes: {
    label: string;
    placeholder: string;
  };
  answerData: {
    description: string;
    front: string; // JSON string with drawing data
    back: string; // JSON string with drawing data
    frontImage: string; // base64 PNG image
    backImage: string; // base64 PNG image
  };
}

/**
 * Checks if a string value is a Healthie body diagram annotation
 */
export function isBodyDiagramData(value: string | undefined): boolean {
  if (!value || typeof value !== 'string') return false;

  try {
    const parsed = JSON.parse(value);
    return (
      parsed?.view?.front !== undefined &&
      parsed?.view?.back !== undefined &&
      parsed?.answerData?.frontImage !== undefined &&
      parsed?.answerData?.backImage !== undefined
    );
  } catch {
    return false;
  }
}

/**
 * Parses body diagram data from a JSON string
 */
export function parseBodyDiagramData(value: string): BodyDiagramData | null {
  try {
    const parsed = JSON.parse(value);
    if (isBodyDiagramData(value)) {
      return parsed as BodyDiagramData;
    }
    return null;
  } catch {
    return null;
  }
}
